<h1 mat-dialog-title>Localisation du versement</h1>
<form (ngSubmit)="onSubmit()" [formGroup]="dialogForm" style="margin-top: 20px">
  <mat-dialog-content class="mat__typography">
    <div fxLayout="column" >
      <div>
        <mat-form-field appearance="outline" fxFlex="calc(90% - 25px)">
          <mat-label>Magasin</mat-label>
          <mat-select formControlName="mag">
            <mat-option *ngFor="let mg of (magasins$ | async)?.list" [value]="mg" [attr.data-cy]="'option-dialog-archived-' + mg.id">{{mg.label}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="line-half">
        <mat-form-field   appearance="outline">
          <mat-label>N° Epi...</mat-label>
          <input type="text" matInput formControlName="epi" placeholder="N° Epi..." maxlength="16" name="epi" data-cy="input-dialog-archived-epi">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>N° Travée...</mat-label>
          <input type="text" matInput formControlName="tra" placeholder="N° Travée..." maxlength="16" name="tra" data-cy="input-dialog-archived-tra">
        </mat-form-field>
      </div>
      <div class="line-half">
        <mat-form-field appearance="outline">
          <mat-label>Rayonnage...</mat-label>
          <input type="text" matInput formControlName="ray" placeholder="Rayonnage..." maxlength="16" name="ray" data-cy="input-dialog-archived-ray">
        </mat-form-field>

        <mat-form-field  appearance="outline">
          <mat-label>Tablette...</mat-label>
          <input type="text" matInput formControlName="tab" placeholder="Tablette..." maxlength="16" name="tab" data-cy="input-dialog-archived-tab">
        </mat-form-field>
      </div>
    </div>
  </mat-dialog-content>

  <div mat-dialog-actions align="end">
    <button mat-raised-button (click)="onNoClick()" color="primary" data-cy="btn-dialog-archived-cancel">Annuler</button>
    <button mat-raised-button
            cdkFocusInitial
            color="accent"
            type="submit"
            [disabled]="!dialogForm.valid" data-cy="btn-dialog-archived-send">Envoyer
    </button>
  </div>
</form>
